<template>
    <div>
        <left-column :style="{backgroundImage:bgImg}"></left-column>
        <right-column>
            <h2>{{$t('step_type.heading')}}</h2>
            <p>{{$t('step_type.subheading')}}</p>
            <ul class="wgCalcRoofTypes">

                <li v-for="slp of slopes" :key="'slope'+slp.key" :class="{selected:slp.key==slope}" @click="slope = slp.key">
                    {{$t('slopes.'+slp.key)}}
                    <span>{{slp.degrees}}</span>
                </li>
            </ul>
            <v-select
                class="mt-8"
                v-model="material"
                :items="roof_materials"
                :label="$t('step_type.roof_type')"

            >
            </v-select>


        </right-column>
    </div>
</template>
<script>
import LeftColumn from "../LeftColumn";
import RightColumn from "../RightColumn";
import steps from './mixins/steps';
import { slopes,SLOPE_0,SLOPE_15,SLOPE_30, roof_materials } from "../../helpers";

export const STEP_KEY = 'roofType'
export default {
    name:'StepRoofType',
    mixins:[steps],
    components: {
        LeftColumn,
        RightColumn
    },
    data(){
        return {
            slope:this.$storage.state.summary.roof.type || SLOPE_15,
            slopes,
            material:'',
            roof_materials
        }
    },
    computed:{
        bgImg(){
            return `url(${require('@/assets/bg/house/house_'+this.slope.toString()+'deg.jpg')})`;
        },
        isValid(){
            return undefined !== this.slope;
        }
    },
    mounted() {
        if(this.$storage.state.summary.roof.type){
            this.slope = this.$storage.state.summary.roof.type;
        }
        if(this.$storage.state.summary.roof.material){
            this.material = this.$storage.state.summary.roof.material;
        }

    },
    methods:{
        applyNext(){
            if(this.$storage.state.passed.indexOf(STEP_KEY)<=0){
                this.$storage.state.passed.push(STEP_KEY);
            }

            this.$storage.state.summary.roof.type = this.slope;
            this.$storage.state.summary.roof.material = this.material;
            this.$storage.state.currentStep = this.$storage.state.steps[this.$storage.state.steps.indexOf(this.$storage.state.currentStep)+1];
        }
    }

}
</script>
<style lang="scss">
.wgCalc{
    &RoofTypes{
        list-style: none;
        margin: 0;
        padding: 0 !important;
        li{
            display: flex;
            flex-direction: row;
            -webkit-box-align: center;
            align-items: center;
            -webkit-box-pack: justify;
            justify-content: space-between;
            cursor: pointer;
            max-width: 360px;
            background-color: $light;
            padding: 1.25rem;
            margin: 0 0 15px 0;
            transition: all 0.1s ease;

            &:hover{
                background-color: darken($light, 5);
            }
            &.selected{
                background: var(--solar-calc-primary-color-bg);;
                color: #FFF;
            }
        }
    }
}
</style>
